import React from 'react';
import { Spinner } from 'reactstrap';

import "./style.css";


function Loader({ fullscreen, children }) {
    let component = (<Spinner animation="border"/>);

    if (children) {
        component = <div className="loader-container">{component}<div>{children}</div></div>;
    }

    if (fullscreen) {
        return <div className="loader fullscreen"><div>{component}</div></div>;
    }

    return component;
}


export default Loader;